import { Injectable } from '@angular/core';
import { RoutesList } from 'src/app/models/enums/RoutesList';
import { DataService } from './data.service';
import { environment } from 'src/environments/environment';
import { enUS, he } from 'date-fns/locale';
import { hebrewDays } from '../constants/hebrew-days';
import { englishDays } from '../constants/english-days';

@Injectable({
  providedIn: 'root',
})
export class LocalizationService {
    private static _currentCultureCode: string | null = null;
    static defultCultureCode: string = 'he-IL';

    availableCultures: any[] = [];

    constructor(private dataService: DataService) { 
        this.availableCultures = [{ code: 'he-IL', name: 'עברית' }]; //default value
        this.getAvailableCultures();
    }

    private static initCultureCode() {
        let cultureCodeElem = <HTMLInputElement>document.getElementById('currentCultureCode');
        let cultureCode = cultureCodeElem ? cultureCodeElem.value : LocalizationService.defultCultureCode;
        this._currentCultureCode = cultureCode;
    }

    static getCurrentCultureCode(): string {
        if(!this._currentCultureCode)
        {
            this.initCultureCode();
        }
        return this._currentCultureCode!;
    }

    getCurrentShortCultureName(): string {
        let culture = this.availableCultures.find(c => c.code === LocalizationService.getCurrentCultureCode());
        return culture ? culture.shortName : '';
    }

    setCurrentCultureCode(cultureCode: string) {
        if(cultureCode === LocalizationService.getCurrentCultureCode())
            return;

        let url = environment.apiUrl + '/Portal/Localization-Api/GetPageUrlByCulture';
        
        let request = {
            cultureCode: cultureCode,
            nodeId: this.dataService.currentPageNodeId
        };
        
        this.dataService.getDataByToken(url, request).subscribe({
            next: (data) => {
              if(data) {
                window.open(RoutesList.BasePrivate + data.url, '_self')
              }
            },
            error: (e) => console.error(e),
          });
    }

    static getRoute(route: RoutesList): string {
        switch(this.getCurrentCultureCode()) {
            case 'he-IL':
                return route.replace('/:lang', '');
            case 'en-US':
                return route.replace(':lang', 'en');
            default:
                return route;
        }
    }

    getAvailableCultures() {
        let url = environment.apiUrl + '/Portal/Localization-Api/GetAvailablePortalLanguages';
        this.dataService.getDataByToken(url, null).subscribe({
            next: (data) => {
              if(data) {
                if(data) {
                    this.availableCultures = data;
                }
              }
            },
            error: (e) => console.error(e)
        });
    }

    static showHebrewElements(): boolean {
        return this.getCurrentCultureCode().toLowerCase() === 'he-IL'.toLowerCase();
    }

    static getCurrentLocale(): Locale {
        switch(this.getCurrentCultureCode()) {
            case 'he-IL':
                return he;
            case 'en-US':
                return enUS;
            default:
                return he;
        }
    }

    static getDaysOfWeek(): string[] {
        switch(this.getCurrentCultureCode()) {
            case 'he-IL':
                return hebrewDays.slice(0,6);
            case 'en-US':
                return englishDays.slice(0,6);
            default:
                return hebrewDays.slice(0,6);
        }
    }
}
